import { render, staticRenderFns } from "./RSpinner.vue?vue&type=template&id=e960edde&scoped=true"
import script from "./RSpinner.vue?vue&type=script&lang=js"
export * from "./RSpinner.vue?vue&type=script&lang=js"
import style0 from "./RSpinner.vue?vue&type=style&index=0&id=e960edde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e960edde",
  null
  
)

export default component.exports